// Analytics event tracking utility

export const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
};

// Common events
export const analytics = {
  // Checkout events
  beginCheckout: (amount, quantity, isExpressShipping, hasCoupon) => {
    trackEvent('begin_checkout', {
      currency: 'aud',
      value: amount,
      items: [{
        item_name: 'Custom Printed Tile',
        quantity: quantity,
        price: amount / quantity
      }],
      shipping_tier: isExpressShipping ? 'Express' : 'Standard',
      coupon_applied: hasCoupon
    });
  },

  // Purchase completed
  purchase: (orderId, amount, quantity, shippingTier) => {
    trackEvent('purchase', {
      transaction_id: orderId,
      currency: 'aud',
      value: amount,
      shipping_tier: shippingTier,
      items: [{
        item_name: 'Custom Printed Tile',
        quantity: quantity,
        price: amount / quantity
      }]
    });
  },

  // File upload events
  fileUpload: (fileSize, fileType) => {
    trackEvent('file_upload', {
      file_size: fileSize,
      file_type: fileType
    });
  },

  // Navigation events
  pageView: (pageName, pageTitle, pageLocation) => {
    trackEvent('page_view', {
      page_name: pageName,
      page_title: pageTitle || document.title,
      page_location: pageLocation || window.location.href,
      page_path: window.location.pathname
    });
  },

  // Error events
  error: (errorType, errorMessage, componentName) => {
    trackEvent('error', {
      error_type: errorType,
      error_message: errorMessage,
      component: componentName
    });
  }
}; 